import { useApi } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { Hero } from "@/components/home/Hero";
import { Pillars } from "@/components/home/Pillars";
import { SituationSelector } from "@/components/home/SituationSelector";
import { OurPromise, AboutIntro, TrustedSupport } from "@/components/home/HomeSections";
import { Loading } from "@/components/site/Loading";

export default function Home() {
  useSeo(null, "Direction, support and understanding for families, partners and friends affected by someone else's addiction in the UK.");
  const { data, loading } = useApi("/home");
  if (loading || !data) return <Loading />;
  const c = data.content;
  return (
    <>
      <Hero content={c} />
      <SituationSelector pathways={data.pathways} />
      <Pillars />
      <OurPromise statement={c.promise_statement} />
      <AboutIntro text={c.about_text} />
      <TrustedSupport services={data.featured_services} />
      <section className="container-site pb-4">
        <p className="font-serif text-2xl sm:text-3xl text-center max-w-3xl mx-auto leading-snug" data-testid="home-closing-message">{c.closing_message}</p>
      </section>
    </>
  );
}
